/* Deonica rute — dve uzastopne tačke između kojih je vozilo prešlo neki put.

   Ruta je niz tačaka na svakih par sekundi. Dispečeru linija kaže kuda je
   vozilo prošlo, ali ne i KAKO: kojom brzinom, u koje vreme, koliko je tu
   prešlo. Sve to stoji između dve susedne tačke — u deonici.

   Zato prelazak mišem preko rute nalazi NAJBLIŽU deonicu i pokazuje njene
   podatke, umesto da se za svaku tačku crta zasebna oznaka (na ruti od 48h to
   bi bilo nekoliko hiljada oznaka i mapa bi stala). */

/* Rastojanje tačke od DUŽI, ne od njenih krajeva. Bez toga bi se pri prelasku
   preko sredine duge deonice pogađala susedna, kraća — jer joj je kraj bliži
   od bilo kog kraja one preko koje se zaista prelazi.

   Računa se u ravni, ne po sferi: deonica je desetak do par stotina metara, a
   na toj razmeri je greška projekcije zanemarljiva. Geografska dužina se skalira
   sa `cos(lat)` da stepen ne bi bio „širi" nego što jeste. */
const rastojanjeOdDuzi = (t, a, b) => {
    const k = Math.cos((a[0] * Math.PI) / 180);
    const px = (t.lng - a[1]) * k, py = t.lat - a[0];
    const dx = (b[1] - a[1]) * k,  dy = b[0] - a[0];

    const duzina = dx * dx + dy * dy;
    // Dve tačke na istom mestu (vozilo stoji) — nema duži, meri se do tačke.
    if (duzina === 0) return px * px + py * py;

    let u = (px * dx + py * dy) / duzina;
    u = Math.max(0, Math.min(1, u));   // van duži pada na njen kraj

    const rx = px - u * dx, ry = py - u * dy;
    return rx * rx + ry * ry;
};

/* Koja deonica je pod mišem. Vraća indeks PRVE tačke deonice, ili -1.

   `prekid` tačke se preskaču: to nije pređeni put nego rupa u praćenju (tunel,
   ugašen uređaj), pa bi „prosečna brzina" preko nje bila izmišljena. */
export const nadjiSegment = (tacke, latlng) => {
    if (!tacke || tacke.length < 2) return -1;

    let najbolji = -1;
    let najmanje = Infinity;

    for (let i = 0; i + 1 < tacke.length; i++) {
        if (tacke[i + 1].prekid) continue;
        const d = rastojanjeOdDuzi(
            latlng,
            [tacke[i].lat, tacke[i].lng],
            [tacke[i + 1].lat, tacke[i + 1].lng]
        );
        if (d < najmanje) { najmanje = d; najbolji = i; }
    }
    return najbolji;
};

/* Pređeni put u metrima (haversine). Ovde je sfera obavezna: zbir mnogo malih
   deonica se koristi i kao kilometraža, a greška ravne projekcije se u zbiru
   nakuplja. */
export const rastojanjeM = (a, b) => {
    const R = 6371000;
    const rad = (x) => (x * Math.PI) / 180;
    const dLat = rad(b.lat - a.lat);
    const dLng = rad(b.lng - a.lng);
    const h = Math.sin(dLat / 2) ** 2
            + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
};

/* SP vraća „30.08.2026. 23:49:10" — datum i vreme se ovde samo razdvajaju.
   Formatiranje ostaje u SP-u (pravilo iz CLAUDE.md), front ga ne prepravlja. */
export const razdvojVreme = (s) => {
    const t = String(s || '').trim();
    const i = t.lastIndexOf(' ');
    if (i < 0) return { datum: t, vreme: '' };
    return { datum: t.slice(0, i), vreme: t.slice(i + 1) };
};

/* Metri ispod kilometra, pa kilometri — „0.14 km" se čita lošije od „141 m",
   a „1400 m" lošije od „1.4 km". */
export const duzinaTeksta = (m) => {
    if (m == null) return '';
    return m < 1000
        ? `${Math.round(m)} m`
        : `${(m / 1000).toLocaleString('sr-RS', { maximumFractionDigits: 2 })} km`;
};

/* Sve što kartica i oblačić prikazuju o jednoj deonici — na jednom mestu, da
   se hover i klik ne razidju u brojkama. */
export const opisSegmenta = (tacke, i) => {
    if (i < 0 || !tacke || i + 1 >= tacke.length) return null;
    const a = tacke[i], b = tacke[i + 1];

    const metara = rastojanjeM(a, b);
    /* Prosek je sredina brzina na krajevima, a NE put/vreme: uređaj se javlja
       na nekoliko sekundi i ta dva broja su mereni podatak, dok bi put/vreme
       nad tako kratkim razmakom uvećavao svaku grešku pozicije. */
    const prosek = Math.round(((a.brzina || 0) + (b.brzina || 0)) / 2);

    return { a, b, metara, prosek, datum: razdvojVreme(a.vreme).datum };
};
